/* eslint-disable react/jsx-handler-names */

import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';


export class ModalManagerComponent extends Component {
  static propTypes = {
    onInit: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      modals: [],
    };
  }

  render() {
    const len = this.state.modals.length;
    if (len === 0) {
      return null;
    } else {
      return (
        <Fragment>
          {this.state.modals.map((modal, idx) => (
            <modal.component
              key={modal.key}
              isOnTop={idx === len - 1}
              body={modal.component}
              onSuccess={modal.onSuccess}
              onCancel={modal.onCancel}
              modalProps={modal.config.modalProps}
              {...modal.config}
            />
          ))}
        </Fragment>
      );
    }
  }

  componentDidMount() {
    if (this.props.onInit)
      this.props.onInit(this);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/ModalManagerComponent.js